import{jsxs as e,jsx as t}from"react/jsx-runtime";import{useState as o,useEffect as a}from"react";import n from"tailwind-styled-components";import l from"clsx";import{Menu as r}from"lucide-react";const s=n.div`
  sidebar-layout
  flex
  flex-grow
  overflow-x-hidden
  relative
`,i=n.div`
  sidebar-layout__sidebar
  bg-white
  absolute
  duration-500
  min-h-full
  px-6
  py-4
  transition-transform
  z-40

  md:bg-transparent
  md:shadow-none
  md:static
  md:translate-x-0
  md:z-auto
`,d=n.div`
  sidebar-layout__content
  flex-1
  max-w-full
  min-h-full
  px-6
  py-4
`,m=n.div`
  sidebar-layout__overlay
  absolute
  bg-black/20
  bottom-0
  duration-500
  left-0
  right-0
  top-0
  transition-opacity
  z-10
`,c=n.button`
  sidebar-layout__toggle
  absolute
  appearance-none
  bg-slate-500
  border-none
  duration-500
  inline-flex
  items-center
  leading-none
  p-2
  text-white
  top-4
  transition-transform
  z-20

  md:hidden
`,u=({children:n,className:u,contentClassName:f="",contentStyle:p,onSidebarToggle:b,overlayClassName:y="",reverseLayout:x=!1,sidebarClassName:h="",sidebarContent:g,sidebarStyle:v,sidebarVisible:w,sidebarWidth:N=320,style:_,toggleClassName:C=""})=>{const z="boolean"==typeof w,[k,S]=o(!1);a((()=>{"boolean"==typeof w&&S(w)}),[w]);const j=()=>{S(!k),"function"==typeof b&&b(!k)},L=l(h,{"shadow-lg":k,"shadow-none":!k,...x?{"translate-x-full":!k,"md:translate-x-0":k,"translate-x-0":k}:{"translate-x-0":k,"md:shadow-none":k,"md:translate-x-0":k,"-translate-x-full":!k}}),T=l(y,{"opacity-100":k,"pointer-events-auto":k,"md:opacity-0":k,"md:pointer-events-none":k,"opacity-0":!k,"pointer-events-none":!k}),V=l(C,{"left-full":!x,"right-full":x,"rounded-l":x,"rounded-r":!x}),W=l(u,{"flex-row-reverse":x});return e(s,{className:W,style:_,children:[e(i,{className:L,role:"complementary",style:{...v,...{width:N}},children:[g,!z&&t(c,{className:V,role:"button",onClick:j,children:t(r,{size:16})})]}),t(d,{className:f,role:"region",style:p,children:n}),t(m,{className:T,onClick:z?void 0:j,role:"none"})]})},f=n.section`
  flex
  flex-col
  min-h-screen
`;export{f as LayoutContainer,u as default};
